/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.ready(() => App.groupings.init());

App.modal_ready(() => App.groupings.populate_contact_ids());


App.groupings = {
  init() {
    return $(document)
      .off('click', '.js-membership-groupings', App.groupings.update_groups)
      .on('click', '.js-membership-groupings', App.groupings.update_groups);
  },


  update_groups() {
    const group_ids = [];

    $('#modal-groups-form').parent().find('.fancy-checkbox-wrapper>input:checked').each(function() {
      const num_id = $(this).attr('id').split('-').pop();
      return group_ids.push(num_id);
    });

    return $('#group-membership-ids').val(group_ids);
  },

  // When the add-to-groups modal opens, populate its hidden
  // field with the selected contact_membership_ids
  populate_contact_ids() {
    // only do this if "select multiple" mode is on.
    // single contact edit mode will pass the contact ID
    // through the query string.
    if (App.select_multiple.active() && $(".js-add-multiple-to-group-contact-membership-ids")[0]) {
      const contact_membership_ids = [];
      $('.js-sm-contacts').children().each(function() {
        const num_id = $(this).attr('id').split('-').pop();
        return contact_membership_ids.push(num_id);
      });

      return $(".js-add-multiple-to-group-contact-membership-ids").val(contact_membership_ids.join(","));
    }
  }
};
